module.exports = __webpack_public_path__ + "img/Transferencia-bancariaa.15d5953d.svg";